import React, { Component } from 'react';
import { connect } from 'react-redux';

class AdminUserDetailContainer extends Component {
    render() {
        return (
            <div>
                AdminUserDetailContainer
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
}
const mapDispatchToProps = (dispatch) => {
    return {

    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminUserDetailContainer);
